import React from 'react';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { CitizenCvItem, JobWishDto } from '../../../../../api-service/clients';
import { Row } from '../../../../../components/row';
import { Cell } from '../../../../../components/cell';
import { FasitDataGridToolbar } from '../../../../../components/data-grid/fasit-data-grid-toolbar';

interface ICvResultDetailsProps {
  item: CitizenCvItem;
}

export function CvResultDetails(props: ICvResultDetailsProps) {
  const { item } = props;
  const { jobWishes } = item;

  const columns: GridColDef[] = [
    {
      field: 'jobWish',
      headerName: 'Jobønske',
      flex: 1,
    },
    {
      field: 'hasEducation',
      headerName: 'Har uddannelse',
      valueFormatter: ({ value }) => (value ? 'Ja' : '-'),
      width: 200,
    },
    {
      field: 'hasExperienze',
      headerName: 'Har erfaring',
      width: 200,
      valueGetter: ({ row }: { row: JobWishDto }) => ((row.numberOfMonthsExperience || 0) > 0 ? 'Ja' : '-'),
    },
    {
      field: 'latestYearActive',
      headerName: 'Seneste aktive erfaring',
      width: 200,
      valueGetter: ({ row }: { row: JobWishDto }) => ((row.latestYearActive || 0) > 0 ? row.latestYearActive : '-'),
    },
    {
      field: 'numberOfMonthsExperience',
      headerName: 'Samlet erfaring',
      valueFormatter: ({ value }) => calculateYearAndMonths(value),
      flex: 1,
    },
  ];

  function CustomToolbar() {
    return FasitDataGridToolbar({
      title: 'Erfaring indenfor jobønske',
      showColumnButton: false,
      showDensityButton: false,
      showFilterButton: false,
    });
  }

  return (
    <Box sx={{ backgroundColor: 'white', padding: 5, borderBottom: 'solid 1px lightgray' }}>
      <Row>
        <Cell size="full">
          <DataGridPro<JobWishDto>
            columns={columns}
            rows={jobWishes || []}
            getRowId={row => row.jobWish!}
            autoHeight
            density="compact"
            components={{
              Toolbar: CustomToolbar,
            }}
            isRowSelectable={() => false}
          />
        </Cell>
      </Row>
    </Box>
  );
}

function calculateYearAndMonths(value: number) {
  if (value === 0) {
    return '-';
  }
  if (value < 12) {
    return `${value} måneder`;
  }
  const yearsCalculated = Math.floor(value / 12);
  const monthsCalculated = value - yearsCalculated * 12;
  const years = yearsCalculated > 0 ? `${yearsCalculated} år` : '';
  const months = monthsCalculated > 0 ? `og ${monthsCalculated} måneder` : '';

  return `${years} ${months}`;
}
